import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-header-kh',
  templateUrl: './app-header-kh.component.html',
  styleUrls: ['./app-header-kh.component.scss']
})
export class AppHeaderKhComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-header-kh/app-header-kh.component.ts